import { Label, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalClock16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, useEffect } from 'react';

import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';

import { TooltipContent } from '../../components/TooltipContent';

export const EarlyAccessLabelContainer: FC = () => {
  const ca = useCAForCard();

  useEffect(() => {
    ca({ category: 'label', action: 'show', label: 'early_access' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tooltip
      placement={'bottom-start'}
      theme={'white'}
      title={
        <TooltipContent>
          <UIText2>
            Это жилье недавно опубликовали. Вы можете связаться с арендодателем раньше остальных: первые несколько часов
            просмотр контактов платный
          </UIText2>
        </TooltipContent>
      }
    >
      <Label
        background="decorative-lavender-transparent"
        color="decorative-purple"
        data-testid="publisher-labels.early-access"
        icon={<IconFunctionalClock16 color="decorative-purple" />}
      >
        Ранний доступ
      </Label>
    </Tooltip>
  );
};
